module.exports = "<div class=\"row no-gutters\">\n  <div class=\"col-2\">\n    <button \n      (click)=\"removeFromCart()\"\n      class=\"btn btn-secondary btn-block\">-</button> \n  </div>\n  <div class=\"col text-center quantity\">\n    {{ shoppingCart.getQuantity(product) }} in cart\n  </div>\n  <div class=\"col-2\">\n    <button \n      (click)=\"addToCart()\"\n      class=\"btn btn-secondary btn-block\">+</button> \n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/shared/components/product-quantity/product-quantity.component.html
// module id = ../../../../../src/app/shared/components/product-quantity/product-quantity.component.html
// module chunks = main